import React, { ReactElement } from 'react';
import { useAtomValue } from 'jotai/index';
import { UpcomingReleasesAtom } from '../../store/DiscoverStore';
import { Link } from '../../Devon/Components/InkyLink';
import KodanshaWheelItem from '../KodanshaWheel/KodanshaWheelItem';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import KodanshaSlider from '../KodanshaSlider';
import './UpcomingReleasesWheelStrip.scss';

export function UpcomingReleasesWheelStrip(): ReactElement | null {
    const items = useAtomValue(UpcomingReleasesAtom);
    if (items.length === 0) {
        return null;
    }
    return (
        <div className='UpcomingReleasesWheelStrip'>
            <KodanshaSlider title='I see more manga in your future...' subtitle='UPCOMING RELEASES'>
                {items.slice(0, 20).map(item => (
                    <KodanshaWheelItem key={item.content?.id} product={item} cta={item.cta} title={item.content?.title ?? ''} />
                ))}
            </KodanshaSlider>
            <Link to='/calendar/'>
                <KodanshaArrow text='View Release Schedule' withArrow={true} />
            </Link>
        </div>
    );
}
